import {Component, OnInit, ViewChild} from '@angular/core';
import {NotificationsService} from '../../../services/notifications.service';
import {NotificationTableRowModel} from '../../../models/NotificationTableRowModel';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificationActionEnum} from '../../../models/NotificationActionEnum';
import {EmailService} from '../../../services/email.service';
import {PostNotificationEmailRequestDto} from '../../../models/PostNotificationEmailRequestDto';
import {LocalDataSource} from 'ng2-smart-table';
import * as moment from 'moment';

@Component({
    selector: 'app-notifications-table',
    templateUrl: './notifications-table.component.html',
    styleUrls: ['./notifications-table.component.css']
})
export class NotificationsTableComponent implements OnInit {
    @ViewChild('modalContent') modalContent;
    emailForm: FormGroup;
    fogbugzForm: FormGroup;
    selectedNotification: NotificationTableRowModel;
    selectedNotificationMessageArray: Array<string>;
    NotificationActionEnum = NotificationActionEnum;
    selectedNotifationAction: NotificationActionEnum;
    responseMessage: string;
    isLoading = false;

    settings = {
        attr: {
            'class': 'table table-striped notifications-table'
        },
        pager: {
            perPage: 15
        },
        actions: false,
        columns: {
            createdAt: {
                title: 'Created at',
                filter: false,
                valuePrepareFunction: (value) => {
                    return moment(value).format('YYYY-MM-DD hh:mm:ss');
                }
            },
            website: {
                title: 'Website',
                filter: false
            },
            page: {
                title: 'Page',
                filter: false
            },
            reviewAgent: {
                title: 'Review agent',
                filter: false,
            },
            reviewType: {
                title: 'Review type',
                filter: false,
            },
            lastAverageScore: {
                title: 'Last score',
                filter: false
            },
            mainAverageScore: {
                title: 'Main score',
                filter: false
            },
            allowedDeviation: {
                title: 'Allowed deviation',
                filter: false
            },
            status: {
                title: 'Status',
                filter: false
            }
        }
    };

    data: Array<NotificationTableRowModel>;
    source: LocalDataSource;

    constructor(private notificationsService: NotificationsService,
                private emailService: EmailService,
                private modalService: NgbModal,
                private fb: FormBuilder) {
    }

    ngOnInit() {
        this.notificationsService.getAllNotifications().subscribe(response => {
            this.data = response.body;
            this.source = new LocalDataSource(this.data);
        });
        this.emailForm = this.fb.group({
            'email': ['', [Validators.email]]
        });
    }

    onUserRowSelect(data: any): any {
        this.selectedNotification = data.data;
        this.createNotificationMessageHtml(this.selectedNotification.message);
        this.modalService.open(this.modalContent);
    }

    createNotificationMessageHtml(message: string) {
        this.selectedNotificationMessageArray = message.split('\r\n');
        // Remove the crap :)
        this.selectedNotificationMessageArray.shift();
        this.selectedNotificationMessageArray.shift();
        this.selectedNotificationMessageArray.pop();
        this.selectedNotificationMessageArray.pop();
    }

    onEmailFormSubmit($event): void {
        if (!this.emailForm.valid) {
            console.log('not valid');
            return;
        }
        const emailRequest = new PostNotificationEmailRequestDto();
        emailRequest.to = this.emailForm.value['email'];
        emailRequest.notificationId = this.selectedNotification.id;
        this.isLoading = true;
        this.emailService.createNotificationEmail(emailRequest).subscribe(response => {
            this.responseMessage = response.toString();
            this.isLoading = false;
        }, error => {
            this.responseMessage = error.error;
            this.isLoading = false;
        });
    }

    onSearch(query: string = '') {
        if (query.length < 1) { // Handle eEmpty table on empty filter string issue
            this.source.setFilter([]);
        } else {
            this.source.setFilter([
                // fields we want to include in the search
                {
                    field: 'website',
                    search: query
                },
                {
                    field: 'page',
                    search: query
                },
                {
                    field: 'reviewAgent',
                    search: query
                },
                {
                    field: 'reviewType',
                    search: query
                }
            ], false);
            // second parameter specifying whether to perform 'AND' or 'OR' search
            // (meaning all columns should contain search query or at least one)
            // 'AND' by default, so changing to 'OR' by setting false here
        }
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/notifications/notifications-table/notifications-table.component.ts